import importAll from 'import-all.macro';
import { IoMdLock, IoMdMenu } from 'react-icons/io';
import { Link } from 'react-router-dom';
import HomeLayout from '../../layouts/HomeLayout';
import { getRoutes } from '../../utils';
import Home from './Home';
import Faq from './Faq';
import Why from './Why';
import Contact from './Contact';
import Video from './Video';

const sections = getRoutes(importAll.sync('./*/index.tsx'));

function Landing() {
  return (
    <HomeLayout
      navProps={{
        links: sections.map((section) => ({
          to: `/#${section.routeProps?.path ?? ''}`,
          children: section.routeProps?.label,
          onClick() {
            const id = section.routeProps?.path?.replace(/[/#]/g, '');
            if (!id) return;

            const el = document.getElementById(id);
            window.scrollTo(0, el?.offsetTop ?? 0);
          },
        })),
        actions: [
          {
            variant: 'solid',
            children: 'Sign In',
            buttonColor: 'primary-1',
            to: '/login',
            as: Link,
          },
        ],
      }}
      footerItems={[
        {
          label: 'Navigation',
          items: sections.map((section) => ({
            to: `/#${section.routeProps?.path ?? ''}`,
            children: section.routeProps?.label,
            onClick() {
              const id = section.routeProps?.path?.replace(/[/#]/g, '');
              if (!id) return;

              const el = document.getElementById(id);
              window.scrollTo(0, el?.offsetTop ?? 0);
            },
          })),
        },
        {
          label: 'Legal',
          items: [
            {
              children: 'Privacy Policy',
              to: '/privacy',
              icon: IoMdLock,
            },
            {
              children: 'Terms & Conditions',
              to: '/terms',
              icon: IoMdMenu,
            },
          ],
        },
        {
          label: 'Account',
          items: [
            {
              children: 'Dashboard',
              to: '/home',
            },
          ],
        },
      ]}
    >
      <Home />
      <Video />
      <Why />
      <Faq />
      <Contact />
    </HomeLayout>
  );
}

Landing.routeProps = {
  index: true,
  path: '/',
};
export default Landing;
